<template>
    <div class="benefit-card-block">
        <div class="benefit-card-image-box">
        <img v-if="previewImage" :src="previewImage" alt=""
            class="benefit-card-image feature-cards-block-background-image">
            <benefit-logo-badges :logoImage="logoImage.data" />
        </div>

        <h2 class="benefit-card-title">{{ title }}</h2>

        <benefit-filters-list :segment="segment" :card-type="cardType" use-short-name/>

        <p class="benefit-card-description">{{ previewDescription }}</p>

        <template>
            <router-link :to="`../beneficios/` + slug" class="benefit-card-link"
                :data-name="`../beneficios/` + slug"></router-link>
        </template>
    </div>
</template>
<script>

import SectionMixin from '@/mixins/sectionMixin'

import benefitLogoBadges from '@/components/benefit/benefit-logo-badges';
import benefitFiltersList from '@/components/benefit/benefit-filters-list';

export default {
    name: 'benefit-card',
    mixins: [SectionMixin],
    components: {
        benefitLogoBadges,
        benefitFiltersList
    },
    props: {
        type: String,

        slug: String,
        title: String,
        previewDescription: String,
        segment: String,
        cardType: {
            type: Array,
            default: () => []
        },

        previewImage: String,
        logoImage: []
    },
}
</script>

<style lang="less" scoped>
    @import "../../../styles/vars.less";

    .benefit-card-block{
        position: relative;
        display: inline-flex;
        flex-direction: column;
        grid-column: span 2;
        margin-bottom: 28px;
        background: @grey;
        transition: transform 0.3s @custom-ease-1, box-shadow 0.25s @custom-ease-1;
        
        &:nth-child(-n+2){
            grid-column: span 3;
            .benefit-card-title{
                font-size: 2.0625rem;
                min-height: 66px;
            }
            .benefit-card-description{
                font-size: 1.125rem;
            }
            .benefit-card-image{
                max-height: 278px;
            }
        }
        &:hover{
            transform: matrix(1.01, 0, 0, 1.01, 1, 1);
            z-index: 1;
        }
    }
    .benefit-card-image-box{
        position: relative;
    }
    .benefit-card-image{
        max-height: 220px;
    }
    .benefit-card-title{
        margin: 28px 0 18px;
        min-height: 48px;
        font-size: 1.5rem;
        font-family: @bold;
        color: @blue-dark;
    }
    .benefit-card-description{
        line-height: 1.2;;
    }

    .benefit-card-link{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: block;
    }
    @media screen and (max-width: @tablet) {
        .benefit-card-block{
            padding: 12px;

            &:nth-child(n){
                grid-column: span 2;
                .benefit-card-title{
                    font-size: 1.6em;
                    min-height: initial;
                    word-wrap: break-word;
                }
                .benefit-card-description{
                    font-size: 1em;
                }
                .benefit-card-image{
                    max-height: 220px;
                }
            }
        }
    }
</style>